// Spedizioni e resi della bottega: opzioni dell'editor, testi condivisi e dati delle tariffe.
// Le regole di reso sono quelle di Rarifex (assistenza ordine): le note dell'artigiano
// possono solo aggiungere impegni, mai ridurre i diritti del cliente.
import { fetchPublicShipping } from './shopsApi';

export const DISPATCH_OPTIONS = [1, 2, 3, 5, 7, 10];

export const CUSTOM_TIMES = [
  { id: '1-2w', label: '1–2 settimane' },
  { id: '2-4w', label: '2–4 settimane' },
  { id: '1-2m', label: '1–2 mesi' },
  { id: '2m+', label: 'oltre 2 mesi' },
];

export const customTimeLabel = (id) => CUSTOM_TIMES.find((c) => c.id === id)?.label || null;

export const dispatchLabel = (days) => (days ? `entro ${days} ${days === 1 ? 'giorno lavorativo' : 'giorni lavorativi'}` : null);

export const POLICY_TEXT_LIMIT = 300;

// Regole di reso e garanzia valide per tutti gli ordini Rarifex
export const RETURN_RULES = [
  {
    title: '14 giorni per ripensarci',
    text: 'Per le creazioni disponibili e quelle realizzate su ordinazione senza personalizzazioni puoi chiedere il reso entro 14 giorni dalla consegna, senza dover spiegare il motivo. Le spese di rispedizione sono a tuo carico, salvo accordi diversi con la bottega.',
  },
  {
    title: 'Creazioni personalizzate e su misura',
    text: 'Quello che viene realizzato secondo le tue indicazioni non si può restituire per ripensamento (art. 59 del Codice del Consumo).',
  },
  {
    title: 'Difetti, danni e non conformità',
    text: 'Se qualcosa arriva rotto, difettoso o diverso da quanto concordato, la bottega rimedia con riparazione, sostituzione o rimborso, e la rispedizione è a suo carico. Vale anche la garanzia legale di 2 anni.',
  },
  {
    title: 'Come si fa',
    text: 'Da «I miei ordini» apri «Assistenza ordine»: la richiesta arriva alla bottega e Rarifex segue il caso fino al rimborso, se serve.',
  },
];

// ----- Tariffe di spedizione (pubbliche) -----
const cache = new Map();

export const loadShopShipping = (crafterId) => {
  if (!crafterId) return Promise.resolve(null);
  const hit = cache.get(crafterId);
  if (hit && hit.expires > Date.now()) return hit.promise;
  const promise = fetchPublicShipping(crafterId).catch(() => null);
  cache.set(crafterId, { promise, expires: Date.now() + 60_000 });
  return promise;
};

export const clearShopShippingCache = () => cache.clear();

const eur = (v) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(v) || 0);

const daysText = (min, max) => {
  if (!min && !max) return null;
  if (min === max || !max) return `${min} ${min === 1 ? 'giorno lavorativo' : 'giorni lavorativi'}`;
  return `${min}–${max} giorni lavorativi`;
};

// Tariffe in forma leggibile; senza tariffe configurate vale quella standard di Rarifex
export const describeShipping = (data) => {
  if (!data) return [];
  const rules = data.rules?.length ? data.rules : [{ name: 'Spedizione standard', ...data.fallback, is_default: true }];
  return rules.map((r) => ({
    name: r.name || 'Spedizione',
    price: Number(r.price) > 0 ? eur(r.price) : 'Gratis',
    free: r.free_shipping_threshold ? `Gratis per ordini da ${eur(r.free_shipping_threshold)}` : null,
    days: daysText(r.delivery_days_min, r.delivery_days_max),
    perItem: r.combine_shipping === false,
    isDefault: !!r.is_default,
  }));
};

// Riepilogo in una riga (scheda prodotto)
export const shippingHeadline = (data) => {
  const main = describeShipping(data)[0];
  if (!main) return null;
  return main.free ? `${main.price} · ${main.free.toLowerCase()}` : main.price;
};
